<template>
  <div>
    <div class="search-form">
      <el-input v-model="config.dealerName"
                style="width: 300px"
                placeholder="请输入客户名称"
                clearable="">
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table v-loading="loading"
              border
              height="442px"
              :data="list"
              @row-click="handleRowClick">
      <el-table-column label="客户名称"
                       min-width="180"
                       prop="dealerName"></el-table-column>
      <el-table-column label="客户类型"
                       min-width="80">
        <template slot-scope="{row}">{{row.deliveryType === 1 ? '经销商' : '终端客户'}}</template>
      </el-table-column>
      <el-table-column label="联系电话"
                       min-width="120"
                       prop="dealerPhone"></el-table-column>
    </el-table>
    <el-pagination background
                   style="text-align: center;"
                   :current-page="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total"
                   @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'ProductSelectList',
  data () {
    return {
      loading: false,
      list: [],
      config: { pageNum: 1, pageSize: 10, dealerName: '', status: 1 },
      total: 0
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    handleCurrentChange (cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleRowClick (row) {
      const { dealerId, dealerName } = row
      this.$emit('select', { dealerId, dealerName })
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('delivery/getdealers', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
